import { render, staticRenderFns } from "./EditarCondicion.vue?vue&type=template&id=23ff51c7&scoped=true&"
import script from "./EditarCondicion.vue?vue&type=script&lang=js&"
export * from "./EditarCondicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff51c7",
  null
  
)

export default component.exports